$(function () {
    // Initialize multiselect dropdowns
    // get a handle
    var productFilter = $('#productType');
    var resourceFilter = $('#resourceType');

    // check if we are on the resources landing page
    if (resourceFilter.length > 0) {

        // product filter dropdown setup
        productFilter.bsMultiSelect({
            containerClass: "bsmultiselect",
            placeholder: $('#productTypeDefaultValue').val()
        });

        // news filter dropdown setup
        resourceFilter.bsMultiSelect({
            containerClass: "bsmultiselect",
            placeholder: $('#resourceTypeDefaultValue').val()
        });

        GetResourcesPagedData(1);
    }

    $(document).ready(function () {

        // amt dropdown change
        $('#resourceAmtDropdown').change(function () {
            GetResourcesPagedData(1);
        });

        // dropdowns arrow setup
        $('.bsmultiselect').each(function () {
            $(this).append('<i class="fa-solid fa-caret-down"></i>');

            // set the search box to disabled
            var searchBox = $(this).find('input[type="search"]');
            searchBox.prop('disabled', true);
        });

        // closing other dropdowns if a new one is opened
        $('.wt-resource-section').find('.bsmultiselect > ul.form-control').click(function () {
            var formControl = $(this);

            $('.wt-resource-section').find('.bsmultiselect > ul.form-control').each(function (i, e) {
                var dropdown = $(e).siblings('.dropdown-menu');

                if (dropdown.css('display') == 'block' && !$(e).is(formControl)) {
                    dropdown.hide();
                }
            });
        });

        $(document).click(function (e) {

            // clear filter button click
            if ($(e.target).hasClass('btn-close')) {

                if ($('.wt-event-section').find('#eventProductType').length > 0) {
                    GetEventsPagedData(1);
                }
                else if ($('.wt-resource-section').find('#productType').length > 0) {
                    GetResourcesPagedData(1);
                }
            }

            // svg caret down clicked
            if ($(e.target).hasClass('fa-caret-down') && $(e.target).parents('.bsmultiselect') != null) {

                var formControl = $(e.target).siblings('ul.form-control');
                formControl.click();

            }
            // svg path caret down click
            else if ($(e.target).parent().hasClass('fa-caret-down') && $(e.target).parents('.bsmultiselect') != null) {

                var formControl = $(e.target).parent().siblings('ul.form-control');
                formControl.click();

            }
            // selected category click
            else if ($(e.target).hasClass('badge') || $(e.target).parent().hasClass('badge')) {

                var formControl = $(e.target).parents('bsmultiselect').find('ul.form-control');
                formControl.click();

            }
            // seach input 
            else if (e.target.tagName == 'INPUT' && $(e.target).attr('type') == 'search') {

                var formControl = $(e.target).parents('bsmultiselect').find('ul.form-control');
                formControl.click();

            }
            // other elements
            else if (!$(e.target).hasClass('form-control') && !$(e.target).parent().hasClass('bsmultiselect')) {

                var formControls = $('.bsmultiselect > ul.form-control');

                formControls.each(function (i, element) {
                    var dropdown = $(element).siblings('.dropdown-menu');

                    if (dropdown.css('display') == 'block') {
                        dropdown.hide();
                    }
                });

            }
        });
    });


    // product filter dropdown change
    var productContainer = $('#productType + .bsmultiselect');
    var productCheckboxes = productContainer.find('.form-check');
    productCheckboxes.click(function (e) {
        if (e.target.tagName == "LABEL") {
            var input = $(this).find('input');
            var checked = input.prop('checked');

            if (checked) {
                input.prop('checked', false);
            }
            else {
                input.prop('checked', true);
            }
        }

        GetResourcesPagedData(1);
    });

    // resource filter dropdown change
    var resourceContainer = $('#resourceType + .bsmultiselect');
    var resourceCheckboxes = resourceContainer.find('.form-check');
    resourceCheckboxes.click(function (e) {
        if (e.target.tagName == "LABEL") {
            var input = $(this).find('input');
            var checked = input.prop('checked');

            if (checked) {
                input.prop('checked', false);
            }
            else {
                input.prop('checked', true);
            }
        }

        GetResourcesPagedData(1);
    });

});

function GetResourcesPagedData(pageNum) {
    // get a handle
    var resourcesContainer = $('.resources');
    var loader = $('.resources__loading');
    var filterForm = $('.filters');
    var pagination = $('.pagination');
    var noResources = $('.no-resources');

    var resultsContainer = $('.results-data');
    var starting = resultsContainer.find('.starting-number');
    var totalDisplayed = resultsContainer.find('.total-displayed');
    var total = resultsContainer.find('.total');

    resourcesContainer.hide();
    noResources.hide();
    loader.show();

    var productContainer = filterForm.find('#productType + .bsmultiselect');
    var productCheckboxes = productContainer.find('input[type="checkbox"]');

    var productTypes = '';
    productCheckboxes.each(function () {
        if ($(this).prop('checked')) {
            // get the value of the checkbox
            var values = $(this).parents('.bsmultiselect').siblings('#productType').find('option');
            var label = $(this).siblings().text();
            var value = '';

            values.each(function () {
                if ($(this).text() == label) {
                    if (value == '') value = $(this).val();
                    else value += '|' + $(this).val();
                }
            });

            if (productTypes == '') productTypes = value;
            else productTypes += '|' + value;
        }
    });

    var resourceContainer = filterForm.find('#resourceType + .bsmultiselect');
    var resourceCheckboxes = resourceContainer.find('input[type="checkbox"]');

    var resourceTypes = '';
    resourceCheckboxes.each(function () {
        if ($(this).prop('checked')) {

            // get the value of the checkbox
            var values = $(this).parents('.bsmultiselect').siblings('#resourceType').find('option');
            var label = $(this).siblings().text();
            var value = '';

            values.each(function () {

                if ($(this).text() == label) {
                    if (value == '') value = $(this).val();
                    else value += '|' + $(this).val();
                }
            });

            if (resourceTypes == '') resourceTypes = value;
            else resourceTypes += '|' + value;
        }
    });

    var searchText = $('#searchInput').val();
    var newUrl = '?';

    if (productTypes != '') {
        newUrl += "pt=" + productTypes.replace('|', ',');
    }

    if (resourceTypes != '') {
        if (newUrl != '?') newUrl += '&';

        newUrl += 'rt=' + resourceTypes.replace('|', ',');
    }

    if (searchText != null && searchText != '') {
        if (newUrl != '?') newUrl += '&';

        newUrl += 'ss=' + searchText;
    }

    // update url history to save this ajax selection
    if (newUrl != '?') window.history.replaceState(null, null, newUrl);
    else window.history.replaceState(null, null, window.location.pathname);

    var amtToDisplay = $('#resourceAmtDropdown').val();
    var culture = $('body').data('culture');

    $.getJSON("/Resource/GetPagedData", { pt: productTypes, rt: resourceTypes, ss: searchText, pageNumber: pageNum, pageSize: amtToDisplay, culture }, function (response) {

        if (response.data.length > 0) {
            var rowData = "";
            for (var i = 0; i < response.data.length; i++) {
                rowData += ResourceListingTemplate(response.data[i]);
            }

            resourcesContainer.html("");
            resourcesContainer.append(rowData);
            pagination.html("");

            if (response.totalPages > 1) {
                var pagerTemplate = PagingTemplate(response.totalPages, response.currentPage, "GetResourcesPagedData");
                pagination.append(pagerTemplate);
            }

            total.text(response.totalItems);
            starting.text(response.startingItemNum);

            if (response.totalItemsShowing == 1) {
                totalDisplayed.text('');
            }
            else {
                totalDisplayed.text(' - ' + response.totalItemsShowing);
            }

            loader.hide();
            resourcesContainer.show();
        }
        else {
            loader.hide();

            totalDisplayed.text('');
            starting.text('0');
            total.text('0');

            noResources.show();
        }
    });
}

function ResourceListingTemplate(resource) {

    var template = '<div class="resource"><div class="resource__inner">';

    if (resource.listingImage != null) {
        template += `<div class="resource__img"><a href="${resource.listingButtonURL}"><img src="${resource.listingImage.directUrlPreview}" alt="${resource.listingImage.altText}" /></a></div>`;
    }

    template += `<div class="resource__content"><a href="${resource.listingButtonURL}"><div class="heading">${resource.listingTitle}</div>`;
    template += `<div class="text">${resource.listingText}</div></a></div></div></div>`;

    return template;
}